import API from "../API Service/ApiCalls";
import ApiService from "../API Service/ApiService";
import { appConstants } from "../Pages/AppConstants";
var apiService = new ApiService();

class EventServiceController {
  getPrimaryEventsList = async () => {
    var response = await apiService.getData(API.primaryEvents, {});
    var json = await response.json();
    return json;
  };

  getSecondaryEventsList = async (levelId) => {
    var response = await apiService.getData(API.secondaryEvents, { "levelId": levelId, "clientId": appConstants.clientId, "isPublished": false });
    var json = await response.json();
    return json;
  };

  addUpdateSecondaryEvents = async (requestBody) => {
    var response = await apiService.postDataSelected(API.addUpdateSecondaryEvents, {}, requestBody);
    return response;
  };

  publishSecondaryEvents = async (id) => {
    var response = await apiService.postData(API.publishSecondaryEvent, { "id": id });
    return response;
  };

  deleteSecondaryEvents = async (id) => {
    var response = await apiService.postData(API.deleteSecondaryEvent, { "id": id });
    return response;
  };

  getFieldValuesforAddCandidate = async (id) => {
    var response = await apiService.getData(API.getFieldValuesforAddCandInfo, { "eventId": id });
    var json = await response.json();
    return json;
  }

  getTaskNamesforAddCandidate = async () => {
    var response = await apiService.getData(API.taskList, { "clientId": appConstants.clientId, "isPublished": true });
    var json = await response.json();
    return json;
  }

  editCreateSecondaryEvents = async (requestBody) => {
    var response = await apiService.postData(API.creatEditSecEvents, {}, requestBody);
    return response;
  }

  getEditEventDetails = async (eventId) => {
    var response = await apiService.postData(API.getEventDetails, { "eventId": eventId, "clientId": appConstants.clientId });
    return response;
  }

  getMailConfigDetails = async () => {
    var response = await apiService.postData(API.mailConfigurations, { "clientId": appConstants.clientId });
    return response;
  }

  deleteMailConfig = async (id) => {
    var response = await apiService.postData(API.mailConfigurationDelete, { "id": id });
    return response;
  };

  addUpdateMailConfig = async (requestBody) => {
    var response = await apiService.postData(API.addUpdateMailConfig, {}, requestBody);
    return response;
  }

  addEventConfig = async (requestBody) => {
    var response = await apiService.postData(API.addClientEventConfig, {}, requestBody);
    return response;
  }

  getEventLevelList = async (levelId) => {
    var response = await apiService.getData(API.primaryEvents, { "levelId": levelId });
    var json = await response.json();
    return json;
  };

  addUpdateEvents = async (requestBody) => {
    var response = await apiService.postDataSelected(API.addUpdateEvents, {}, requestBody);
    return response;
  };

  addUpdateEventRule = async (requestBody) => {
    var response = await apiService.postDataSelected(API.addUpdateEventRule, {}, requestBody);
    return response;
  };

  getRulesEventRule = async (eventId) => {
    var response = await apiService.getData(API.getRulesEventRule, { "eventId": eventId });
    var json = await response.json();
    return json;
  };

  deleteRulesEventRule = async (Id) => {
    var response = await apiService.postDataSelected(API.deleteEventRule, { "Id": Id });
    return response;
  };

  getConstaintsRulesEventValue = async () => {
    var response = await apiService.getData(API.getConstaintsRulesEventValue, {});
    var json = await response.json();
    return json;
  };

  getCalloutNameFromConstraint = async (eventId, constraintId) => {
    var response = await apiService.getData(API.getCalloutNameFromConstraint, { "eventId": eventId, "constraintId": constraintId });
    var json = await response.text();
    return json;
  };

  getInactivePrimaryEventsList = async (flag) => {
    var response = await apiService.getData(API.primaryEvents, { "levelId": 0, "flag": flag });
    var json = await response.json();
    return json;
  };

}
export default EventServiceController;